﻿export default function FavoritesPage() { return <div className='container' style={{paddingTop:'32px'}}><h1>Favorilerim</h1></div>; }
